/**
 * PROMPTS VERSIONADOS DO INSPECT IA REVIEW — um lugar só (nunca em tela).
 *
 * Cada revisão grava `promptVersion` (id@versão). As regras obrigatórias do
 * comando estão no texto de cada template e valem para QUALQUER provedor:
 * o motor local as implementa em código; um provedor externo futuro as
 * recebe como instrução de sistema.
 */
export interface PromptTemplate {
  readonly id: "REPORT_GRAMMAR_REVIEW" | "REPORT_TECHNICAL_REVIEW" | "TECHNICAL_ASSISTANT";
  readonly version: string;
  readonly system: string;
  /** Formato exigido da resposta (validado antes de persistir). */
  readonly outputFormat: "FINDINGS_JSON" | "ANSWER_JSON";
}

export const PROMPT_TEMPLATES: readonly PromptTemplate[] = [
  {
    id: "REPORT_GRAMMAR_REVIEW",
    version: "V1",
    outputFormat: "FINDINGS_JSON",
    system:
      "Corrija ortografia, gramática, concordância e pontuação em português brasileiro, preservando integralmente números, identificadores, unidades, normas, códigos, TAGs e significado técnico. " +
      "Classifique cada correção. Só marque autoApplicable=true para mudanças puramente linguísticas (SAFE_LANGUAGE_CHANGE). " +
      "Responda somente com {\"findings\":[{fieldPath,category,severity,originalText,suggestedText,explanation,autoApplicable}]}."
  },
  {
    id: "REPORT_TECHNICAL_REVIEW",
    version: "V1",
    outputFormat: "FINDINGS_JSON",
    system:
      "Não invente resultados, valores, normas, mecanismos de dano ou condições não presentes no contexto. Quando a evidência for insuficiente, indique incerteza e solicite revisão humana. " +
      "Aponte incoerências entre resultados e conclusão, recomendações sem evidência e termos técnicos suspeitos. Nunca proponha alterar números, TAGs, datas, normas ou revisões. " +
      "Correções técnicas são sempre sugestão (autoApplicable=false). Responda somente com {\"findings\":[...]}."
  },
  {
    id: "TECHNICAL_ASSISTANT",
    version: "V1",
    outputFormat: "ANSWER_JSON",
    system:
      "Responda com base no contexto do relatório e nos trechos da Base Técnica fornecidos. Toda afirmação normativa precisa citar documento, revisão e seção. " +
      "Se não houver suporte nos trechos, responda: \"Não encontrei suporte suficiente na base técnica configurada para confirmar esta afirmação.\" " +
      "Não invente resultados, valores, normas ou condições. Você não aprova relatórios nem escreve no documento."
  }
];

export function promptTemplate(id: PromptTemplate["id"]): PromptTemplate {
  const t = PROMPT_TEMPLATES.find(p => p.id === id);
  if (!t) throw new Error(`Prompt ${id} não cadastrado.`);
  return t;
}

export const promptVersionOf = (id: PromptTemplate["id"]) => `${id}_${promptTemplate(id).version}`;

export const NO_KNOWLEDGE_SUPPORT = "Não encontrei suporte suficiente na base técnica configurada para confirmar esta afirmação.";
